import { useState } from "react";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

export default function useVolunteerShopList() {
  const { api, AdminId } = useGlobalContext();

  const [volunteerShops, setVolunteerShops] = useState([]);
  const [filteredVolunteerShops, setFilteredVolunteerShops] = useState([]);
  const [loading, setLoading] = useState(false);

  const shouldShowLocalError = (data) => {
    return (
      data?.responseCode !== "00" &&
      data?.responseCode !== "02" &&
      data?.responseCode !== "03" &&
      data?.responseCode !== "98" &&
      data?.responseCode !== "401"
    );
  };

  const getVolunteerUserId = () => {
    try {
      const volunteerData = JSON.parse(
        sessionStorage.getItem("volunteerData") || "{}"
      );

      return String(
        volunteerData?.userId ||
          volunteerData?.userid ||
          volunteerData?.id ||
          AdminId ||
          ""
      );
    } catch (error) {
      return String(AdminId || "");
    }
  };

  // =========================
  // FETCH SHOP LIST
  // =========================
  const fetchVolunteerShops = async () => {
    setLoading(true);

    try {
      const body = {
        adminId: getVolunteerUserId(),
        userid: "",
      };

      const res = await api.post(
        "/api/VolunteerShop/v1.0/getVolunteerShopList",
        body
      );

      if (res?.data?.responseCode === "00") {
        const shops = Array.isArray(res?.data?.data) ? res.data.data : [];

        setVolunteerShops(shops);
        setFilteredVolunteerShops(shops);

        return shops;
      }

      if (shouldShowLocalError(res?.data)) {
        toast.error(
          res?.data?.responseMessage || "Failed to fetch volunteer shop list"
        );
      }

      setVolunteerShops([]);
      setFilteredVolunteerShops([]);

      return [];
    } catch (err) {
      console.error("fetchVolunteerShops error:", err);
      toast.error("Error fetching volunteer shop list");

      setVolunteerShops([]);
      setFilteredVolunteerShops([]);

      return [];
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // ASSIGN SHOP TO VOLUNTEER
  // =========================
  const assignShopToVolunteer = async (volunteerId, shopId) => {
    try {
      const body = {
        volunteerId: String(volunteerId || ""),
        shopId: String(shopId || ""),
      };

      const response = await api.post(
        "/api/VolunteerUser/v1.0/assignShopToVolunteer",
        body
      );

      if (response?.data?.responseCode === "00") {
        toast.success(
          response?.data?.responseMessage || "Shop assigned successfully"
        );

        return true;
      }

      if (shouldShowLocalError(response?.data)) {
        toast.error(
          response?.data?.responseMessage || "Failed to assign shop"
        );
      }

      return false;
    } catch (error) {
      console.error("assignShopToVolunteer error:", error);
      toast.error("Something went wrong while assigning shop");

      return false;
    }
  };

  return {
    volunteerShops,
    setVolunteerShops,
    filteredVolunteerShops,
    setFilteredVolunteerShops,
    loading,
    fetchVolunteerShops,
    assignShopToVolunteer,
    getVolunteerUserId,
  };
}